/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CalculationDtoDetails {
  /**
   * Zysk flipera (zł)
   * @min 0
   */
  flipperProfitAmount?: number;
  /**
   * Zysk flipera (%)
   * @min 0
   */
  flipperProfitPercent?: number;
  /**
   * Zysk inwestora (zł)
   * @min 0
   */
  investorProfitAmount?: number;
  /**
   * Zysk inwestora (%)
   * @min 0
   */
  investorProfitPercent?: number;
  /**
   * Kapitał flipera (zł)
   * @min 0
   */
  flipperCapitalAmount?: number;
  /**
   * Kapitał flipera (%)
   * @min 0
   */
  flipperCapitalPercent?: number;
  /**
   * Kapitał inwestora (zł)
   * @min 0
   */
  investorCapitalAmount?: number;
  /**
   * Kapitał inwestora (%)
   * @min 0
   */
  investorCapitalPercent?: number;
  /**
   * Stopa zwrotu - ROI
   * @min 0
   */
  roi?: number;
  /**
   * Stopa zwrotu - ROE Flippera
   * @min 0
   */
  flipperRoe?: number;
  /**
   * Stopa zwrotu - ROE Inwestora
   * @min 0
   */
  investorRoe?: number;
  /**
   * Marża brutto
   * @min 0
   */
  margin?: number;
  /**
   * Potencjalny zysk netto
   * @min 0
   */
  estimatedProfitNetto?: number;
  /** Budżet projektu / potrzebny kapitał */
  projectCapital?: number;
}

export interface FilterDtoDetails {
  /**
   * Notariusz
   * @min 0
   */
  notary?: number;
  /**
   * Pcc
   * @min 0
   */
  pcc?: number;
  /**
   * Procent posrednika przy zakupie mieszkania
   * @min 0
   */
  brokerPercent?: number;
  /**
   * Czynsz miesięczny
   * @min 0
   */
  rentFees?: number;
  /**
   * Opłaty eksploatacyjne miesięczne za m2
   * @min 0
   */
  maintenanceFees?: number;
  /**
   * Inne koszta eksploatacyjne
   * @min 0
   */
  otherMaintenanceCosts?: number;
  /**
   * Ogłoszenia portali
   * @min 0
   */
  portalFees?: number;
  /**
   * Fotograf
   * @min 0
   */
  photographerAmount?: number;
  /**
   * Koszt remontu z materiałami
   * @min 0
   */
  renovation?: number;
  /**
   * Meble ruchome, wyposażenie
   * @min 0
   */
  equipment?: number;
  /**
   * Home staging
   * @min 0
   */
  homeStaging?: number;
  /**
   * Procent pośrednika przy sprzedaży
   * @min 0
   */
  saleBrokerPercent?: number;
  /**
   * Inne koszta sprzedaży
   * @min 0
   */
  otherSaleCosts?: number;
  /**
   * Media miesięczne
   * @min 0
   */
  mediaCosts?: number;
  /**
   * Inne koszta około zakupowe
   * @min 0
   */
  otherPurchaseCosts?: number;
  /**
   * Pozostałe koszta
   * @min 0
   */
  otherCosts?: number;
  /**
   * Koszty finansowania (odsetki)
   * @min 0
   */
  saleInterest?: number;
}

export interface FlipStagesDtoDetails {
  /**
   * Wartość pierwszego etapu flipa
   * @min 0
   */
  firstStage?: number;
  /**
   * Wartość drugiego etapu flipa
   * @min 0
   */
  secondStage?: number;
  /**
   * Wartość trzeciego etapu flipa
   * @min 0
   */
  thirdStage?: number;
  /**
   * Koszta końcowe flipa
   * @min 0
   */
  finalCosts?: number;
  /**
   * Niewykorzystany budżet flipa
   * @min 0
   */
  unusedBudget?: number;
}

export interface InvestmentFilterRequestDtoDetails {
  /**
   * Id fitra
   * @format int64
   * @min 1
   */
  id: number;
  /** Nazwa fitra */
  name: string;
  /**
   * Data zakupu mieszkania
   * @format date
   */
  purchaseDate?: string;
  /**
   * Data sprzedaży mieszkania
   * @format date
   */
  saleDate?: string;
  /** Adres inwestycji */
  address?: string;
  /**
   * Cena mieszkania
   * @min 1
   */
  price: number;
  /**
   * Cena sprzedaży mieszkania
   * @min 1
   */
  salePrice: number;
  /**
   * Czas trwania inwestycji
   * @format int64
   * @min 1
   */
  investmentTime: number;
  /**
   * Metraż mieszkania
   * @min 1
   */
  area: number;
  /**
   * Liczba pokoi
   * @format int32
   * @min 1
   */
  rooms?: number;
  /**
   * Piętro
   * @format int32
   * @min 0
   */
  floor?: number;
  filter?: FilterDtoDetails;
  calculation?: CalculationDtoDetails;
  flip?: FlipStagesDtoDetails;
}

export interface CalculateByParamRequest {
  /** Pole do obliczenia */
  param?: CalculateByParamRequestParamEnum;
  /**
   * Metraż
   * @min 0
   */
  area?: number;
  /**
   * Cena mieszkania
   * @min 0
   */
  price?: number;
  /**
   * Cena sprzedaży mieszkania
   * @min 0
   */
  salePrice?: number;
  /**
   * Kapitał projektu
   * @min 0
   */
  projectCapital?: number;
  /**
   * Potencjalny zysk netto
   * @min 0
   */
  estimatedProfitNetto?: number;
  /**
   * Wartość parametru
   * @min 0
   */
  value?: number;
}

/** Pole do obliczenia */
export enum CalculateByParamRequestParamEnum {
  MAINTENANCE_FEES = "MAINTENANCE_FEES",
  RENT_FEES = "RENT_FEES",
  BROKER = "BROKER",
  SALE_BROKER = "SALE_BROKER",
  RENOVATION = "RENOVATION",
  PCC = "PCC",
  FLIPPER_CAPITAL = "FLIPPER_CAPITAL",
  INVESTOR_CAPITAL = "INVESTOR_CAPITAL",
  FLIPPER_PROFIT = "FLIPPER_PROFIT",
  INVESTOR_PROFIT = "INVESTOR_PROFIT",
  REMAINING = "REMAINING",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  investment = {
    /**
     * No description
     *
     * @tags Panel analityczny inwestycji
     * @name FindUserFilters
     * @request GET:/investment/filter
     * @secure
     */
    findUserFilters: (params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/investment/filter`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Aktualizacja filtra
     *
     * @tags Panel analityczny inwestycji
     * @name Update
     * @summary Aktualizacja filtra
     * @request PUT:/investment/filter
     * @secure
     */
    update: (data: InvestmentFilterRequestDtoDetails, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/investment/filter`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Tworzenie filtra na podstawie przekazanych parametrów
     *
     * @tags Panel analityczny inwestycji
     * @name Create
     * @summary Tworzenie filtra
     * @request POST:/investment/filter
     * @secure
     */
    create: (data: InvestmentFilterRequestDtoDetails, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/investment/filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Zwraca obliczoną inwestycję bez potrzeby tworzenia
     *
     * @tags Panel analityczny inwestycji
     * @name Predict
     * @summary Obliczanie inwestycji na podstawie parametrów
     * @request POST:/investment/filter/predict
     * @secure
     */
    predict: (data: InvestmentFilterRequestDtoDetails, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/investment/filter/predict`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Zwraca obliczoną wartość dla danego parametru
     *
     * @tags Panel analityczny inwestycji
     * @name CalculateParam
     * @summary Obliczanie wartości parametru
     * @request POST:/investment/filter/calculate
     * @secure
     */
    calculateParam: (data: CalculateByParamRequest, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/investment/filter/calculate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Panel analityczny inwestycji
     * @name FindUserFilter
     * @request GET:/investment/filter/{filterId}
     * @secure
     */
    findUserFilter: (filterId: number, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/investment/filter/${filterId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Panel analityczny inwestycji
     * @name DeleteUserFilter
     * @request DELETE:/investment/filter/{filterId}
     * @secure
     */
    deleteUserFilter: (filterId: number, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/investment/filter/${filterId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Zwraca filtr z domyślnymi globalnymi ustawieniami
     *
     * @tags Panel analityczny inwestycji
     * @name FindDefaultFilter
     * @summary Pobieranie domyślnego filtra
     * @request GET:/investment/filter/default
     * @secure
     */
    findDefaultFilter: (params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/investment/filter/default`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
